<template>
  <div>
    <van-pull-refresh v-model="isLoading" @refresh="getir"></van-pull-refresh>
    <van-card
      v-for="(item, index) in $store.getters.getBasket"
      :key="index"
      :title="$helper.ilkharfBuyuk(item.isim).substring(0, 80)"
      :desc="'Miktar : '+item.miktar + ' adet Marka: ' + $helper.ilkharfBuyuk(item.marka)"
      thumb="https://egemyazilim.com/urun-resmi-yok.jpeg"
      @click = "detay(item,index)"
    >
        <template #tags>
          <van-tag plain type="warning" v-if="item.fiyat.maliyet>0">
            {{
            $helper.parabirimi((item.fiyat.maliyet),hesap.pb)
            }}
          </van-tag>
          <van-tag plain type="warning" v-if="item.fiyat.maliyet>0">
            {{
            $helper.parabirimi((item.fiyat.maliyet*item.sepetadet),hesap.pb)
            }}
          </van-tag>
          <van-stepper v-model="item.sepetadet" 
          :max="item.miktar"
          style="margin: 5px 5px 5px 5px;"  
          @plus="change(item,1)"
          @minus="change(item,-1)"
          />
        </template>
    </van-card>
    <detay v-if="detayac" 
     :show="detayac" 
     :depolar="$store.getters.getStok.aktif.depomiktar" 
     :durum="icon"
     @closePop="closePop()"
     />  
     <van-field
      v-model="siparis.notu"
      rows="2"
      autosize
      label=""
      type="textarea"
      maxlength="100"
      placeholder="Açıklama"
      show-word-limit
      style="background:#f2f2f2;margin-top: 10px;"
    />
     <van-button block style="margin: 10px 0 60px 0" pure color="#7232dd" @click="stokkontrol()">SİPARİŞ VER</van-button>  
  </div>
</template>

<script>
import detay from "@/components/detay";
export default {
  components:{
    detay
  },  
  data() {
    return {
      hata:[],
      basladim:false,
      hesap :  this.$store.getters.getHesap,
      icon: {
        1: {
          icon: "passed",
          text: "Stok var",
          color:'green'
        },
        2: {
          icon: "fire-0",
          text: "Kritik stok",
          color:'yellow'

        },
        3: {
          icon: "clock-o",
          text: "Stok yolda",
          color:'blue'

        },
        4: {
          icon: "close",
          text: "Stok yok",
          color:'red'
        },
      },      
      isLoading: false,
      obj:{
        ckod: this.$store.getters.getCari.aktif.kod,
        cari_iskonto_kod:this.$store.getters.getCari.aktif.iskontokod,
        where: {
          anagrup: [],
          altgrup: [],
          marka: [],
          guid: 0,
          kelime: '',
          web: 0,
          mevcut:0,
          kampanya: 0,
          yeni: 0,
        },
        gruplama: 0,
        order: {
          key: 'isim',
          value: 'asc'
        },
        sayfa:1,
        sayfalama: 1000 // çalışmıyor
      },
      detayac:false,
      siparis: {
        fid:  this.$store.getters.getHesap.fid,
        cKod: this.$store.getters.getCari.aktif.kod,
        cari: this.$store.getters.getCari.aktif.unvan,
        nerden: "P",
        plasiyer:  this.$store.getters.getHesap.kid,
        teslim: 1,
        notu: "",
        odemeTip: 0,
        toplam: 0,
      },      
    };
  },
  created(){
    this.$store.commit("setLoading",false)
    this.getir()
  },
  methods: {
    // mikro kayıt
    siparisekle(arr) {
      this.$swal({
        title: "Onaylıyor musunuz?",
        text: "Siparişi Ekliyorum ...",
        type: "warning",
        //showCancelButton: true,
        confirmButtonText: "Evet",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$store.commit("bekle", true);
          let obj = {
            ayar : this.obj,
            teslim : this.siparis.teslim,
            notu : this.siparis.notu,
            arr : arr
          }
          //console.log(obj)
            this.$store.dispatch("siparisekle",obj).then(response=>{
              response.forEach(e => {
                if (e.status) {
                  this.deletus(arr,e.guid)
                }
              });
              setTimeout(() => {
                    this.$store.commit("bekle", false);

                  this.$swal.fire({
                  position: "top-end",
                  type: "success",
                  title: "Sipariş Ekleme Başarılı",
                  showConfirmButton: false,
                  timer: 1000,
                });
              }, 1000);
            })
        }
      })
    },
   // mikro kayıt bitiş
    stokkontrol() {
      this.siparis.toplam = 0;
      this.$dialog.confirm({
        title: "Satışı ekliyorum",
        message: "Onaylıyormusunuz ?",

      }).then(() => {
          let source = this.$store.getters.getBasket
          this.hata = [];
          const run = async () => {
            for (let index = 0; index < source.length; index++) {
              const e = source[index];
              e.secili = true;
              e.hata = false;
              if (e.secili) {
                let durum = await this.tampon(e);
                if (durum.durum) {
                  this.siparis.toplam = this.siparis.toplam + e.fiyat.maliyet;
                } else {
                  this.hata.push({
                    kod: e.parcano,
                    mesaj: "Stok Müsait değil",
                    miktar: durum.miktar,
                  });
                  e.hata = true;
                  e.secili = false;
                }
              }
            }
            if (this.hata.length == 0) {
              this.baslat()
            }
          };
          run();
 
      });
    },
    tampon(e) {
      return new Promise((resolve, reject) => {
          this.obj.where.guid = e.guid;
          this.$request
            .post("basket/satinal", {giden:this.obj,adet:e.sepetadet})
            .then((res) => {
              resolve(res);
            });
      });
    },
    baslat() {
      //local kayıt
      let source = this.$store.getters.getBasket
      this.$request.post("crm/siparisekle", this.siparis).then((res) => {
        //console.log(res.id);
        for (let index = 0; index < source.length; index++) {
          const e = source[index];
          setTimeout(() => {
            if (e.secili) {
              let obje = {
                siparisid: res.id,
                urunid: e.guid,
                adet: e.sepetadet,
                fiyat: e.fiyat.maliyet,
                iskontofiyat: e.fiyat.kdvsiz,
                kdv: e.kdv,
                kdvt: e.kdvt,
                fiyattip:'normal', //e.fiyattip,
                reyon: 0,
                iskonto: e.fiyat.iskonto,
                ekleyen: this.hesap.kad,
              };
              this.$request.post("crm/siparisSatirEkle", obje).then((res2) => {
                if (res2.status == 200) {
                  //this.deletus(this.posts, e.guid);
                  setTimeout(() => {
                    this.basladim = false;
                    this.$swal("Siparişiniz Başarı ile alındı");
                  }, 1000);
                } else {
                }
              });
            }
          }, 500);
        }
      });
      // })
      // .catch(() => {
      //   this.hata.push({
      //     mesaj: "Limit Yetersiz",
      //     kod: 0,
      //   });
      // });
    },
    getir() {
      this.$store.commit("setLoading",true)
      
      this.$request.post("basket/list/", {giden : this.obj},this.hesap).then((response) => {
        console.log(response)
          this.$store.commit('setBasket',response)
          this.$store.commit("setLoading",false)
        });
    },
    detay(obj) {
      this.detayac = true
      this.$request.post(this.hesap.program+"/depo/miktar",{ stok : obj.guid,stokkod :obj.kod }).then((res) => {
        this.$store.commit('setDepomiktar',res.data)
    })
    },
    change(obje,adet){
      obje.adet = adet;
      let obj = {
        obje :obje,
        helper : this.$helper,
        req : this.$request,
        notify:this.$notify,
        dialog:this.$dialog,
      }
      this.$store.dispatch("sepetupdate",obj)
    },
    closePop(){
      this.detayac = false
    }  
    },
};
</script>
<style scoped>
.sepetAdet {
  padding: 2px 3px !important;
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  }
  .van-tag--warning {
    background-color: none;
    padding: 6px 5px;
    font-size: 13px;
    font-weight: 600;
   
}
.van-tag--danger {
    padding: 3px 3px !important;

}
</style>


// WEBPACK FOOTER //
// src/views/sepet.vue